"use strict";

var timeF = require('lmw-time-format');
/**
 * 时间戳格式化
 * @param str
 * @param format
 * @returns {string}
 */
module.exports = function (str, format) {
  if (!str) return "";
  return timeF(parseInt(str), format);
};